import React, { Fragment, useEffect } from "react";

import ListItem from "../../ListItem/ListItem";
import { ProductCategoryLink } from "../../../data/contentUnitMenu";
import { supplierCategoryMenu } from "../../../data/supplierCategoryMenu";
import BreadCrumb from "../../BreadCrumb/BreadCrumb";

function ProductCategoryMenu({ supplier }) {
  return (
    <Fragment>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="دسته بندی محصولات"
        href1="/dashboard/content-controller"
      />
      <ListItem
        items={supplier ? supplierCategoryMenu : ProductCategoryLink}
        width="350px"
      />
    </Fragment>
  );
}

export default ProductCategoryMenu;
